export default __webpack_public_path__ + "static/media/ngo01.f9d0443e.jpg";